import { createLocationHubCacheListener, createSocketMessageEventListener } from '@/warehouse/signalR';
import { updateStockInvoicesByMessage, updateStockReceiptItemsByMessage } from './helpers';
import { t } from '@/core/localization';
import { showApiErrorSnackbar } from '@/shared/helpers/thunk';
import { baseApi } from '@/warehouse/baseApi';
import { getStockLocationId } from '@/warehouse/helpers';
import { fixStockInvoiceMessage } from '@/warehouse/signalR/helpers/fixStockInvoiceMessage';
import { placedToStockMessageSchema } from '@/warehouse/signalR/types';
import { stockReceiptActions } from './stockReceipt.state';
/** Count of rows that should be rendered inside Invoice table to prevent lagging. */
const maxInvoiceRowCount = 100;
export const stockReceiptApi = baseApi.enhanceEndpoints({ addTagTypes: ['Invoices', 'StockReceiptItems'] }).injectEndpoints({
    endpoints: (builder) => ({
        getStockInvoices: builder.query({
            query: (body) => ({
                url: `stock/${getStockLocationId()}/receipt/invoices`,
                method: 'POST',
                body,
            }),
            onQueryStarted: async (queryArgument, { dispatch, queryFulfilled }) => {
                const { article, isReceipted } = queryArgument;
                // TODO: to delete redundant comments
                // const ownerLocation = (getState() as RootState).receipt.ownerLocation;
                try {
                    const result = await queryFulfilled;
                    // Counters should not be changed if invoices are filtered by search term.
                    if (article)
                        return;
                    if (isReceipted)
                        dispatch(stockReceiptActions.setReceiptedInvoiceCount(result.data?.length));
                    else
                        dispatch(stockReceiptActions.setNotReceiptedInvoiceCount(result.data?.length));
                }
                catch {
                    //
                }
            },
            /*
            onCacheEntryAdded: async (queryArgument, { dispatch, updateCachedData, cacheDataLoaded, cacheEntryRemoved, getCacheEntry }) => {
                const { addEventListener } = locationHubSignalrConnector();
                const { endpointName } = getCacheEntry();

                try {
                    await cacheDataLoaded;

                    const placedToStockEventListener = createSocketMessageEventListener<'PlacedToStock', GetStockInvoicesRequest>({
                        endpointName,
                        queryArgument,
                        validationSchema: placedToStockMessageSchema,
                        validationSchemaPath: 'stockInvoice',
                        messageMutation: (message) => {
                            // TODO: to delete later (this is backend bugs fixes)
                            fixStockInvoiceMessage(message);
                        },
                        listener: ({ validQueryArgument, ...args }) => {
                            updateCachedData((draft) => {
                                // Updating notReceiptedInvoices counter, we must take in account that some of this invoices may be
                                // actually receipted, but still exist in the list, since they were just marked as receipted (greed
                                // background) by socket message.
                                /// const prevItemCount = draft.length; // <= that is not enough
                                const prevItemCount = validQueryArgument.isReceipted
                                    ? draft.length
                                    : draft.filter((item) => item.quantity !== item.receiptedQuantity).length;

                                updateStockInvoicesByMessage({ draft, isReceipted: validQueryArgument.isReceipted, ...args });

                                const nextItemCount = validQueryArgument.isReceipted
                                    ? draft.length
                                    : draft.filter((item) => item.quantity !== item.receiptedQuantity).length;

                                if (prevItemCount !== nextItemCount) {
                                    // // TODO: to delete
                                    // console.log('updated, queryArgument.isReceipted', queryArgument.isReceipted);
                                    // console.log('updated, validQueryArgument.isReceipted', validQueryArgument.isReceipted);
                                    // console.log('updated, prevItemCount', prevItemCount);
                                    // console.log('updated, nextItemCount', nextItemCount);

                                    dispatch(
                                        validQueryArgument.isReceipted
                                            ? stockReceiptActions.setReceiptedInvoiceCount(nextItemCount)
                                            : stockReceiptActions.setNotReceiptedInvoiceCount(nextItemCount)
                                    );
                                }
                            });
                        },
                    });

                    addEventListener('PlacedToStock', placedToStockEventListener);
                } catch {
                    // no-op in case `cacheEntryRemoved` resolves before `cacheDataLoaded`,
                    // in which case `cacheDataLoaded` will throw
                }

                await cacheEntryRemoved;
            },
            */
            onCacheEntryAdded: createLocationHubCacheListener(({ dispatch, updateCachedData, getCacheEntry }, queryArgument) => ({
                PlacedToStock: createSocketMessageEventListener({
                    endpointName: getCacheEntry().endpointName,
                    queryArgument,
                    validationSchema: placedToStockMessageSchema,
                    validationSchemaPath: 'stockInvoice',
                    messageMutation: (message) => {
                        // TODO: to delete later (this is backend bugs fixes)
                        fixStockInvoiceMessage(message);
                    },
                    listener: ({ validQueryArgument, ...args }) => {
                        updateCachedData((draft) => {
                            // Updating notReceiptedInvoices counter, we must take in account that some of this invoices may be
                            // actually receipted, but still exist in the list, since they were just marked as receipted (greed
                            // background) by socket message.
                            /// const prevItemCount = draft.length; // <= that is not enough
                            const prevItemCount = validQueryArgument.isReceipted
                                ? draft.length
                                : draft.filter((item) => item.quantity !== item.receiptedQuantity).length;
                            updateStockInvoicesByMessage({ draft, isReceipted: validQueryArgument.isReceipted, ...args });
                            const nextItemCount = validQueryArgument.isReceipted
                                ? draft.length
                                : draft.filter((item) => item.quantity !== item.receiptedQuantity).length;
                            if (prevItemCount !== nextItemCount) {
                                // // TODO: to delete
                                // console.log('updated, queryArgument.isReceipted', queryArgument.isReceipted);
                                // console.log('updated, validQueryArgument.isReceipted', validQueryArgument.isReceipted);
                                // console.log('updated, prevItemCount', prevItemCount);
                                // console.log('updated, nextItemCount', nextItemCount);
                                dispatch(validQueryArgument.isReceipted
                                    ? stockReceiptActions.setReceiptedInvoiceCount(nextItemCount)
                                    : stockReceiptActions.setNotReceiptedInvoiceCount(nextItemCount));
                            }
                        });
                    },
                }),
            })),
        }),
        getStockReceiptItems: builder.query({
            query: (params) => ({
                method: 'GET',
                url: `stock/${getStockLocationId()}/receipt/items`,
                ...(params ? { params } : {}),
            }),
            onQueryStarted: async ({ invoiceId } = {}, { dispatch, queryFulfilled }) => {
                try {
                    const result = await queryFulfilled;
                    if (!invoiceId) {
                        dispatch(stockReceiptActions.setVerificationItemCount(result.data.receiptItems.length));
                    }
                }
                catch (error) {
                    dispatch(showApiErrorSnackbar({ header: t('get.stock.receipt.items.request.failed'), error }));
                }
            },
            onCacheEntryAdded: createLocationHubCacheListener(({ updateCachedData, getCacheEntry }) => ({
                PlacedToStock: createSocketMessageEventListener({
                    endpointName: getCacheEntry().endpointName,
                    validationSchema: placedToStockMessageSchema,
                    messageMutation: (message) => {
                        // TODO: to delete later (this is backend bugs fixes)
                        fixStockInvoiceMessage(message);
                    },
                    listener: (args) => {
                        updateCachedData((draft) => {
                            updateStockReceiptItemsByMessage({ draft, ...args });
                        });
                    },
                }),
            })),
        }),
        // TODO: later. Duplicated from shared stock.shared.api. Btw it is OLD backend endpoint.
        // And check for IStock!
        getStockInfo: builder.query({
            query: (stockId) => {
                return {
                    method: 'GET',
                    url: `stock/getStock/${stockId}`,
                };
            },
            onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
                try {
                    await queryFulfilled;
                }
                catch (error) {
                    dispatch(showApiErrorSnackbar({ header: t('get.stock.info.request.failed'), error }));
                }
            },
        }),
        // TODO: check if it is used
        getStockCells: builder.query({
            query: () => ({
                method: 'GET',
                url: 'stock/cells',
            }),
        }),
        placeInStock: builder.mutation({
            query: ({ stockReceiptItemId, ...body }) => ({
                method: 'POST',
                url: `stock/${getStockLocationId()}/receipt/${stockReceiptItemId}/place`,
                body,
            }),
            invalidatesTags: (result, error, { stockReceiptItemId }) => error ? [] : [{ type: 'StockReceiptItems', id: stockReceiptItemId }],
        }),
        // TODO: to delete later, this endpoint should only be used in Admin later.
        uploadInvoice: builder.mutation({
            query: (file) => {
                const formData = new FormData();
                formData.append('file', file);
                return {
                    method: 'POST',
                    url: 'stockInvoiceParsing/upload',
                    body: formData,
                };
            },
            transformResponse: ({ cells, ...baseQueryReturnValue }) => {
                return {
                    ...baseQueryReturnValue,
                    cells: cells.slice(0, maxInvoiceRowCount),
                };
            },
        }),
        // TODO: to delete later, this endpoint should only be used in Admin later.
        getParsedInvoiceSettings: builder.query({
            query: () => ({
                method: 'GET',
                url: 'stockInvoiceParsing/settings',
            }),
            /// TODO: to delete later when test empty setting is done.
            // transformResponse: (result: ParsedStockInvoiceSettings) => {
            // 	return {
            // 		invoiceIdCell: undefined,
            // 		dateCell: undefined,
            // 		// articleColumn: {
            // 		// 	position: 1,
            // 		// 	column: undefined,
            // 		// },
            // 		articleColumn: undefined,
            // 		startRow: undefined,
            // 		qtyColumn: undefined,
            // 		priceColumn: undefined,
            // 		brandColumn: undefined,
            // 		nameColumn: undefined,
            // 		countryCodeColumn: undefined,
            // 		gtdColumn: undefined,
            // 		trackingCodeColumn: undefined,
            // 		trackingQtyColumn: undefined,
            // 		trackingSymbolColumn: undefined,
            // 	} as any as ParsedStockInvoiceSettings;
            // },
        }),
        // TODO: to delete later, this endpoint should only be used in Admin later.
        editParsedInvoiceSettings: builder.mutation({
            query: (body) => ({
                method: 'POST',
                url: 'stockInvoiceParsing/settings',
                body,
            }),
        }),
        // TODO: to delete later, this endpoint should only be used in Admin only.
        processInvoice: builder.mutation({
            query: (body) => ({
                method: 'POST',
                url: 'stockInvoiceParsing/process',
                body,
            }),
            invalidatesTags: [{ type: 'Invoices', id: 'LIST' }],
        }),
    }),
});
export const { useGetStockInvoicesQuery, useGetStockReceiptItemsQuery, useGetStockInfoQuery } = stockReceiptApi;
